module.exports = __webpack_public_path__ + "img/20210906-1630911014613790.d3662d2a.jpg";